import Footer from "@/components/Footer";
import { Dimmer } from "@/components/spinner";
import useTableService from "@/components/useTableServerSide";
import { SearchInput } from "@/ui/inputs/Input";
import React, { useState, useMemo, useRef, useEffect } from "react";
import axios from "axios";
import { Mensaje } from "@/components/mensajes2";
import ModalGestionarMulta from "./modalGestionarMulta";

const defaultHeaderStyle = {
  backgroundColor: "rgba(5, 81, 130, 1)",
  color: "#ffffff",
  textAlign: "center",
};

const columnConfigByType = {
  comercio: [
    { id: "idcomercio", label: "CODIGO" },
    { id: "ritm", label: "RITM" },
    { id: "rif", label: "RIF" },
    { id: "nombre", label: "NOMBRE" },
    { id: "direccion", label: "DIRECCIÓN" },
    { id: "reprelegal", label: "CEDULA" },
    { id: "opciones", label: "OPCIONES" },
  ],
  inmueble: [
    { id: "idinmueble", label: "CODIGO", width: "10px", fontSize: "10px" },
    { id: "numficha", label: "N° FICHA", width: "70px", fontSize: "10px" },
    {
      id: "nombrepropie",
      label: "NOMBRE PROPIETARIO",
      width: "250px",
      fontSize: "10px",
    },
    { id: "dirinmueble", label: "DIRECCION", width: "250px", fontSize: "10px" },
    {
      id: "codigocatastral",
      label: "CODIGO CATASTRAL",
      width: "100px",
      fontSize: "10px",
    },
    {
      id: "cedulapropie",
      label: "CEDULA PROPIETARIO",
      width: "200px",
      fontSize: "10px",
    },
    { id: "accion", label: "OPCIONES", width: "120px", fontSize: "10px" },
  ],
  vehiculo: [
    { id: "placa", label: "PLACA", width: "20px" },
    { id: "ritm", label: "RITM", width: "20px" },
    { id: "nombrepropie", label: "NOMBRE", width: "200px" },
    { id: "idvehiculo", label: "CÓDIGO", width: "20px" },
    { id: "accion", label: "OPCIONES", width: "60px" },
  ],
  rentas: [
    { id: "idrentas", label: "CODIGO", width: "200px", fontSize: "10px" },
    { id: "cedrif", label: "CEDULA/RIF", width: "200px", fontSize: "10px" },
    {
      id: "nombrearrendatario",
      label: "NOMBRE ARRENDATARIO",
      width: "300px",
      fontSize: "10px",
    },
    { id: "descripcion", label: "RENTA", width: "200px", fontSize: "10px" },
    { id: "opciones", label: "OPCIONES", width: "60px", fontSize: "10px" },
  ],
  publicidad: [
    { id: "idcomercio", label: "CODIGO", width: "10px", fontSize: "10px" },
    { id: "ritm", label: "RITM", width: "40px", fontSize: "10px" },
    { id: "rif", label: "RIF", width: "40px", fontSize: "10px" },
    { id: "nombre", label: "NOMBRE", width: "300px", fontSize: "10px" },
    { id: "direccion", label: "DIRECCIÓN", width: "200px", fontSize: "10px" },
    { id: "accion", label: "OPCIONES", width: "80px", fontSize: "10px" },
  ],
};

const TITLE_BY_TYPE = {
  comercio: "Asignar Multa Actividades Económicas",
  inmueble: "Asignar Multa Inmuebles Urbanos",
  vehiculo: "Asignar Multa Impuestos de Vehículos",
  rentas: "Asignar Multa Rentas Inmobiliarias",
  apuesta: "Asignar Multa Apuestas Lícitas",
  publicidad: "Asignar Multa Propaganda y Publicidad Comercial",
  licores: "Asignar Multa Rentas de Licores",
};

export default function TablaAsignarMulta(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const searchTimeoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
    orderBy: "",
    orderDir: "",
  });

  // ✅ Estado para el contribuyente (igual que en el código original)
  const [contribuyente, setContribuyente] = useState({
    idcontribuyente: "",
    nombre: "",
    ritm: "",
    rif: "",
    cedula: "",
  });

  const headCells = useMemo(() => {
    const columns = columnConfigByType[props.tipo] || [];
    return columns.map(({ id, label, width, fontSize }) => ({
      id,
      label,
      ...defaultHeaderStyle,
      ...(width && { width }),
      ...(fontSize && { fontSize }),
    }));
  }, [props.tipo]);

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({ ...prev, orderBy, orderDir, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  const buscarComercios = () => {
    setLoading(true);
    const campos = `tipocontribuyente, codigocatastral, idcomercio, nombre, rif, ritm, reprelegal, fechainscripcion, cuenta, direccion, esagentereten, actualizado, status, montopatente`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: "comercio",
      orden: "idcomercio desc",
    };
    const endpoint = `${op.conexion}/api/comun/seleccionar-registros-paginacion`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const buscarInmuebles = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      orderBy: tableState.orderBy,
      orderDir: tableState.orderDir,
      search: tableState.search,
    };
    const endpoint = op.conexion + `/api/catalogo/inmueblesPaginacion`;
    const controller = new AbortController();

    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };

  const buscarVehiculo = () => {
    setLoading(true);
    const campos = `placa, ritm, TRIM(nombrepropie) AS nombrepropie, idvehiculo, cedulapropie,direccionpropie`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: "vehiculo",
      orden: "idvehiculo desc",
    };
    const endpoint = `${op.conexion}/api/comun/seleccionar-registros-paginacion`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const buscarRentas = () => {
    setLoading(true);
    const nomtab = "rentasinmobiliarias";
    const nomid = "idtiporenta";
    const nomtab2 = "tiporentas";
    const nomid2 = "idtiporentas";
    const condi = "codigoimpuesto<3";
    const endpoint = `${op.conexion}/api/aseo/aseo?nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}&condi=${condi} `;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const buscarPublicidad = () => {
    setLoading(true);
    const campos = `*`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: "comercio",
      orden: "idcomercio desc",
    };
    const endpoint = `${op.conexion}/api/comun/seleccionar-registros-paginacion`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const buscarLicores = () => {
    setLoading(true);
    const campos = `l.idlicores, c.ritm, c.nombre, c.direccion, c.reprelegal, c.rif, c.reprelegal`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: `licores l
      inner join comercio c on c.idcomercio = l.idcomercio`,
      orden: "l.idlicores desc",
    };
    const endpoint = `${op.conexion}/api/comun/seleccionar-registros-paginacion`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          setRecords(res.data.rows);
          setTotalRecords(res.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  // ✅ FUNCIÓN COMPLETA DE GESTIONAR CONTRIBUYENTE (COPIADA DEL CÓDIGO ORIGINAL)
  const gestionarContribuyente = (item) => {
    let idcontri = "";
    let nombre = "";
    let ritm = "";
    let direccion = "";
    let rif = "";
    let cedula = "";
    if (props.tipo === "comercio") {
      idcontri = item.idcomercio;
      nombre = item.nombre;
      direccion = item.direccion;
      rif = item.rif;
      ritm = item.ritm;
      cedula = item.reprelegal;
    } else if (props.tipo === "inmueble") {
      idcontri = item.idinmueble;
      nombre = item.nombrepropie;
      direccion = item.dirinmueble;
      rif = item.cedulapropie;
      ritm = item.numficha;
    } else if (props.tipo === "vehiculo") {
      idcontri = item.idvehiculo;
      nombre = item.nombrepropie;
      ritm = item.placa;
      direccion = item.direccionpropie;
      rif = item.cedulapropie;
    } else if (props.tipo === "rentas") {
      idcontri = item.idrentas;
      nombre = item.nombrearrendatario;
    } else if (props.tipo === "publicidad") {
      idcontri = item.idcomercio;
      nombre = item.nombre;
      idcontri = item.idcomercio;
      nombre = item.nombre;
      direccion = item.direccion;
      rif = item.rif;
      ritm = item.ritm;
    } else if (props.tipo === "apuesta") {
      idcontri = item.idapuesta;
      nombre = item.nombre;
    } else if (props.tipo === "licores") {
      idcontri = item.idlicores;
      nombre = item.nombre;
      direccion = item.direccion;
      rif = item.rif;
      ritm = item.ritm;
      cedula= item.reprelegal
    }

    // ✅ Actualizar el estado del contribuyente
    setContribuyente({
      idcontribuyente: idcontri,
      nombre: nombre,
      ritm: ritm,
      direccion: direccion,
      rif: rif,
      cedula: cedula,
    });
    // ✅ Abrir el modal
    setMostrarModal(true);
  };

  // ✅ Función para cerrar el modal
  const handleCerrarModal = () => {
    setMostrarModal(false);
    // Opcional: Recargar los datos si se hizo algún cambio
    // const fetchData = FETCH_BY_TYPE[props.tipo];
    // if (fetchData) fetchData();
  };

  // FUNCIÓN PARA RENDERIZAR FILAS
  const renderTableRows = () => {
    if (!records || records.length === 0) {
      return (
        <tr>
          <td colSpan={headCells.length} className="text-center py-4">
            No hay registros disponibles
          </td>
        </tr>
      );
    }

    return records.map((item, index) => {
      let cells = [];
      let key = index;

      switch (props.tipo) {
        case "comercio":
          key = item.idcomercio || index;
          cells = [
            item.idcomercio,
            item.ritm,
            item.rif,
            item.nombre,
            item.direccion,
            item.reprelegal,
          ];
          break;
        case "inmueble":
          key = item.idinmueble || index;
          cells = [
            item.idinmueble,
            item.numficha,
            item.nombrepropie,
            item.dirinmueble,
            item.codigocatastral,
            item.cedulapropie,
          ];
          break;
        case "vehiculo":
          key = item.idvehiculo || index;
          cells = [item.placa, item.ritm, item.nombrepropie, item.idvehiculo];
          break;
        case "rentas":
          key = item.idrentas || index;
          cells = [
            item.idrentas,
            item.cedrif,
            item.nombrearrendatario,
            item.descripcion,
          ];
          break;
        case "publicidad":
          key = item.idcomercio || index;
          cells = [
            item.idcomercio,
            item.ritm,
            item.rif,
            item.nombre,
            item.direccion,
          ];
          break;
        case "licores":
          key = item.idlicores || index;
          cells = [
            item.idlicores,
            item.ritm,
            item.rif,
            item.nombre,
            item.direccion,
            item.reprelegal,
          ];
          break;
        default:
          cells = [];
      }

      return (
        <tr key={key} style={{ padding: "0" }}>
          {cells.map((value, idx) => (
            <td key={idx} className="align-baseline text-center">
              {value || "-"}
            </td>
          ))}
          <td className="align-baseline text-center" style={{ width: "150px" }}>
            <button
              onClick={() => gestionarContribuyente(item)}
              className="btn btn-sm btn-primary rounded-pill"
            >
              <i className="fas fa-pen-nib"></i> Actualizar
            </button>
          </td>
        </tr>
      );
    });
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  const FETCH_BY_TYPE = {
    comercio: buscarComercios,
    inmueble: buscarInmuebles,
    vehiculo: buscarVehiculo,
    rentas: buscarRentas,
    publicidad: buscarPublicidad,
    licores: buscarLicores,
  };

  useEffect(() => {
    const fetchData = FETCH_BY_TYPE[props.tipo];
    if (fetchData) {
      fetchData();
    }
  }, [props.tipo, tableState]);

  return (
    <div className="col-8 m-0 my-5 p-2 border rounded mx-auto">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
        <h3 className="fw-bold text-light m-0">
          {TITLE_BY_TYPE[props.tipo] || "Asignar Multa"}
        </h3>
        <button onClick={() => cerrar()} className="btn btn-sm bg-light">
          <i className="fa fa-times"></i>
        </button>
      </header>

      <div className="col-4 m-0 my-2 p-0">
        <SearchInput
          className="search-input pe-4"
          value={searchInput}
          onChange={handleSearch}
        />
      </div>

      <section className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>{renderTableRows()}</tbody>
        </TblContainer>
        <TblPagination />
      </section>

      <ModalGestionarMulta
        show={mostrarModal}
        contribuyente={contribuyente}
        onHide={handleCerrarModal}
        tipo={props.tipo}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
